// import withFirebaseCollection from "../HOK/withFirebaseCollection";
// import css from "./priceOpt.module.css";
// import saleThreBlock from "../../img/saleThreBlock.png";
// import rotatePic from "../../img/rotatePic.png";
// import notRotatePic from "../../img/notRotatePic.png";
// import soonPicProd from "../../img/soonPicProd.png";
// import saleNewOne from "../../img/saleNewOne.png";
// import saleNewTwo from "../../img/saleNewTwo.png";
// import { useNavigate } from "react-router-dom";
// const ActionsAnd = ({ data }) => {
//   const navigete = useNavigate();
//   const handleJoinClick = () => {
//     if (data[1].joinLink) {
//       window.open(data[1].joinLink, "_blank");
//     }
//   };

//   const handleDetailsClick = () => {
//     if (data[1].detailsLink) {
//       window.open(data[1].detailsLink, "_blank");
//     }
//   };
//   return (
//     <>
//       {data && data[1] && (
//         <div className={css.salesBlockWrap}>
//           <div className={css.blueBlockWrap}>
//             <h3 className={css.saleForNewYear}>
//               Акція до
//               <br /> Нового року
//             </h3>
//             <div className={css.prdeProdPricingCart}>
//               <div className={css.prdeProdPricingRotateCart}>
//                 <p className={css.salePriceCart}>+5</p>
//                 <p className={css.fullPriceCart}>безкоштовно*</p>
//               </div>
//             </div>
//             <button className={css.buttonJoin} onClick={handleJoinClick}>
//               Приєднатися
//             </button>
//             <img className={css.saleNewOneSt} src={data[1].saleNewOneUrl} />
//             <img className={css.saleNewTwoSt} src={data[1].saleNewTwoUrl} />
//             <img
//               className={css.saleThreBlockSt}
//               src={data[1].saleThreBlockUrl}
//             />
//             <p className={css.vidTwPcs}>*від 20 одиниць</p>
//           </div>
//           <div className={css.yelowBlockWrap}>
//             <h3 className={css.saleForProduction}>
//               Розпродаж у зв'язку зі
//               <br />
//               зняттям з виробництва
//             </h3>
//             <div className={css.prdeProdPricingCartPr}>
//               <div className={css.prdeProdPricingRotateCartPr}>
//                 <p className={css.salePriceCartPr}>-20%</p>
//                 <p className={css.fullPriceCartPr}>знижка</p>
//               </div>
//             </div>
//             <button className={css.buttonJoinPr} onClick={handleDetailsClick}>
//               Детальніше
//             </button>
//             <p className={css.vidTwPcsPr}>до 29 вересня</p>
//             <img className={css.prodNewOneSt} src={data[1].rotatePicUrl} />
//             <img className={css.prodNewTwoSt} src={data[1].notRotatePicUrl} />
//           </div>
//         </div>
//       )}
//     </>
//   );
// };
// export default withFirebaseCollection("pageOpt")(ActionsAnd);
import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import css from "./priceOpt.module.css";

import saleThreBlockDefault from "../../img/saleThreBlock.png";
import rotatePicDefault from "../../img/rotatePic.png";
import notRotatePicDefault from "../../img/notRotatePic.png";
import saleNewOneDefault from "../../img/saleNewOne.png";
import saleNewTwoDefault from "../../img/saleNewTwo.png";

const DEFAULT_BANNER_SETTINGS = {
  joinLink: "",
  detailsLink: "",

  leftTitle: "Акція до\nНового року",
  leftBadgeMainText: "+5",
  leftBadgeSmallText: "безкоштовно*",
  leftButtonText: "Приєднатися",
  leftBottomText: "*від 20 одиниць",

  rightTitle: "Розпродаж у зв'язку зі\nзняттям з виробництва",
  rightBadgeMainText: "-20%",
  rightBadgeSmallText: "знижка",
  rightButtonText: "Детальніше",
  rightBottomText: "до 29 вересня",

  saleNewOneUrl: "",
  saleNewTwoUrl: "",
  saleThreBlockUrl: "",
  rotatePicUrl: "",
  notRotatePicUrl: "",
};

const renderTextWithBreaks = (text) => {
  return String(text || "")
    .split("\n")
    .map((line, index, array) => (
      <React.Fragment key={`${line}-${index}`}>
        {line}
        {index !== array.length - 1 && <br />}
      </React.Fragment>
    ));
};

const ActionsAnd = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(DEFAULT_BANNER_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBannerSettings = async () => {
      try {
        const docRef = doc(db, "pageOpt", "pageSettings");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setSettings({
            ...DEFAULT_BANNER_SETTINGS,
            ...docSnap.data(),
          });
        }
      } catch (error) {
        console.error("Помилка завантаження налаштувань банера:", error);
      } finally {
        setLoading(false);
      }
    };

    loadBannerSettings();
  }, []);

  const handleJoinClick = () => {
    if (settings.joinLink) {
      window.open(settings.joinLink, "_blank");
    }
  };

  const handleDetailsClick = () => {
    if (settings.detailsLink) {
      window.open(settings.detailsLink, "_blank");
    }
  };

  if (loading) return null;

  return (
    <div className={css.salesBlockWrap}>
      <div className={css.blueBlockWrap}>
        <h3 className={css.saleForNewYear}>
          {renderTextWithBreaks(settings.leftTitle)}
        </h3>

        <div className={css.prdeProdPricingCart}>
          <div className={css.prdeProdPricingRotateCart}>
            <p className={css.salePriceCart}>{settings.leftBadgeMainText}</p>
            <p className={css.fullPriceCart}>{settings.leftBadgeSmallText}</p>
          </div>
        </div>

        <button className={css.buttonJoin} onClick={handleJoinClick}>
          {settings.leftButtonText}
        </button>

        <img
          className={css.saleNewOneSt}
          src={settings.saleNewOneUrl || saleNewOneDefault}
          alt="Акційна книга 1"
        />

        <img
          className={css.saleNewTwoSt}
          src={settings.saleNewTwoUrl || saleNewTwoDefault}
          alt="Акційна книга 2"
        />

        <img
          className={css.saleThreBlockSt}
          src={settings.saleThreBlockUrl || saleThreBlockDefault}
          alt="Акційна книга 3"
        />

        <p className={css.vidTwPcs}>{settings.leftBottomText}</p>
      </div>

      <div className={css.yelowBlockWrap}>
        <h3 className={css.saleForProduction}>
          {renderTextWithBreaks(settings.rightTitle)}
        </h3>

        <div className={css.prdeProdPricingCartPr}>
          <div className={css.prdeProdPricingRotateCartPr}>
            <p className={css.salePriceCartPr}>{settings.rightBadgeMainText}</p>
            <p className={css.fullPriceCartPr}>
              {settings.rightBadgeSmallText}
            </p>
          </div>
        </div>

        <button className={css.buttonJoinPr} onClick={handleDetailsClick}>
          {settings.rightButtonText}
        </button>

        <p className={css.vidTwPcsPr}>{settings.rightBottomText}</p>

        <img
          className={css.prodNewOneSt}
          src={settings.rotatePicUrl || rotatePicDefault}
          alt="Книга розпродажу 1"
        />

        <img
          className={css.prodNewTwoSt}
          src={settings.notRotatePicUrl || notRotatePicDefault}
          alt="Книга розпродажу 2"
        />
      </div>
    </div>
  );
};

export default ActionsAnd;
